module.exports = __webpack_public_path__ + "img/pastel_pols-potten.560b0723.jpeg";